<template>
  <div class="bt h-full one-whole pl-small flex flex--column h-full">
    <slot name="searchFilter" />
    <div v-if="favorites.length === 0" class="empty-state pr pl-small mt">
      <div class="empty-state__icon">
        <ak-icon type="heart-outline" color="danger" size="big" />
      </div>
      <p class="empty-state__title mb-tiny">
        <strong>Favorites can give you quick access to your projects</strong>
      </p>
      <p>
        Add a project to your favorites by clicking the
        <ak-icon type="more-vertical" />
        icon next to a project
      </p>
    </div>
    <div v-else style="overflow-y: auto" class="pr-tiny pb-huge">
      <ul class="list-bare mt-small">
        <li
          class="campaign-list-item"
          :class="{ 'is-active': isActive(null) }"
          @click.stop.prevent="setProjectFilter(null)"
        >
          All containers
        </li>
        <li
          v-for="(item, index) in favorites"
          :key="index"
          class="campaign-list-item"
          :class="itemClasses(item)"
        >
          <project-item
            :item="item"
            @click.stop.prevent="setProjectFilter(item._id)"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, inject } from 'vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
import ProjectItem from '../ProjectItem.vue'
import { itemClasses } from '../utils'
export default defineComponent({
  name: 'FavoritesTab',
  components: {
    [Icon.name]: Icon,
    [ProjectItem.name]: ProjectItem,
  },
  props: {
    favorites: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const setProjectFilter = inject('setProjectFilter')
    const isActive = inject('isActive')
    return {
      itemClasses,
      setProjectFilter,
      isActive,
    }
  },
})
</script>
